/**
 * 消息控制组件
 */
import React, { ReactNode, useMemo, useCallback, useContext } from "react";
import ChatState, { UserState } from "@/types/chat/State";
import { AI_CHAT_PREDICT, ChatMessage, ChatMessagePlusEmitBody } from "@/types/chat";
import { connect } from "dva";
import { UserModel } from "@/models/user";
import styles from "./index.module.less";
import IconFont from "@/components/icon";
import { message as Tip, Dropdown, Tooltip } from "antd";
import CopyClipboard from "copy-to-clipboard";
import { getSelected } from "@/utils/chat/message";
import ChatEvent from "@/components/chat/view/ChatEvent";
import ImService from "@/server/ImService";
import AIRemark from "../AIRemark";
import AiRecommendCard from "../AIRecommendCard";
import ChatContext from "@/components/chat/context";
import { generateMessageId } from "@jd/jdee.im.sdk/lib/es/utils/utils";

interface MessageItemProps {
  messageNode: ReactNode;
  sendUserName: ReactNode;
  sendTime: React.ReactElement;
  headPortrait: ReactNode;
  message: ChatMessage & ChatMessagePlusEmitBody;
  index: number;
  getCurrentMessageId: Function;
  setCurrentMessageId: Function;
  unLock: Function;
  getLock: (lock?: boolean) => boolean;
  showOperateBox: boolean;
  userData: UserModel;
  changeSelectMore: Function;
  updateSessionMessageMid: Function;
  updateSessionMessagesTimestamp: Function;
  isRightClick?: boolean;
  saveAsCount: number;
}

type IProps = Readonly<MessageItemProps & ChatState & UserState>;

function QuestionControl(props: IProps) {
  const { lastAIMessage } = useContext(ChatContext);
  const { message, updateSessionMessageMid, selectedSession } = props;
  const copyOperate = useCallback(() => {
    let str = "";
    const userSelection = getSelected();
    if (userSelection?.toString()) {
      str = userSelection.toString();
    }
    if (!str) {
      str = (message as any)?.content;
    }
    if (str && CopyClipboard(str)) {
      Tip.success("复制成功");
    } else {
      Tip.error("复制失败");
    }
  }, [message]);

  const isLastMsg = useMemo(() => {
    return lastAIMessage?.id === message?.id;
  }, [lastAIMessage, message]);

  const retryOperate = useCallback(async () => {
    const msg = message as any;
    const questionId = msg?.questionId;
    if (questionId) {
      // build
      const id = generateMessageId();
      ImService.getInstance().sendLLMMessage(id, {
        predictType: AI_CHAT_PREDICT.REGENERATE,
        questionId: msg?.questionId,
        requestId: msg?.id
      } as any);
      // 重置状态
      updateSessionMessageMid({
        sessionId: selectedSession.sessionId,
        sendResult: {
          body: { ...message, flag: "regenerate" }
        }
      });
    }
  }, [message, selectedSession.sessionId, updateSessionMessageMid]);

  const handleFeedback = useCallback(
    (assess) => {
      updateSessionMessageMid({
        sessionId: selectedSession.sessionId,
        sendResult: {
          body: { ...message, assess }
        }
      });
      ImService.getInstance().updateMessageById(message.sessionId, message.id, { assess });
    },
    [message, selectedSession?.sessionId, updateSessionMessageMid]
  );

  const ContentMenu = useMemo(() => {
    return (
      <div className={styles["operate-container"]}>
        <div className={styles["operate-box"]}>
          <div className={styles["left"]}>
            <Tooltip title="复制">
              <div className={styles["operate-box-item"]} onClick={copyOperate}>
                <IconFont className={styles["icon"]} type="iconic_app_copy" />
              </div>
            </Tooltip>
            {isLastMsg ? (
              <Tooltip title="重新生成">
                <div className={styles["operate-box-item"]} onClick={retryOperate}>
                  <IconFont className={styles["icon"]} type="iconic_app_regenerate" />
                </div>
              </Tooltip>
            ) : null}
          </div>
          <AIRemark
            message={message}
            moduleType="message"
            question={message.content}
            style={{ position: "relative", right: "unset", bottom: "unset" }}
            modelWidth={320}
            onFeedback={handleFeedback}
          />
        </div>
      </div>
    );
  }, [copyOperate, handleFeedback, isLastMsg, message, retryOperate]);

  if (message.id) {
    return (
      <div className={styles["operate-ai-container"]}>
        <div className={styles["tip-wrap"]}>由{(window as any)?._BTS_CONFIG?.REACT_APP_NAME || ""}大模型生成，仅供参考</div>
        {ContentMenu}
        <AiRecommendCard message={message} />
      </div>
    );
  }
  return <div />;
}

function mapStateToProps({ chat, user: { userData } }: any) {
  // eslint-disable-next-line prettier/prettier
    const {
    selectedSession,
    currentEmployee,
    allSessionList,
    sessionMessageMap,
    voiceMessageMap,
    saveAsCount
  } =
    // eslint-disable-next-line prettier/prettier
      chat as ChatState;
  return {
    selectedSession,
    currentEmployee,
    allSessionList,
    userData: userData ? userData.user : {},
    sessionMessageMap,
    voiceMessageMap,
    saveAsCount
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    async deleteSessionMessage(data: { message: ChatMessage }) {
      await dispatch({ type: "chat/deleteSessionMessage", payload: data });
    },
    openCreateModal(data: any) {
      dispatch({ type: "calendar/openCreateModal", payload: data });
    },
    openCreateRemindModal(data: any) {
      dispatch({ type: "supervise/setCreateModalVisible", payload: data });
    },
    changeSelectMore(data: any) {
      dispatch({ type: "chat/changeSelectMore", payload: data });
    },
    updateSessionMessageMid(data: { sendResult: any; sessionId: string }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(QuestionControl);
